import moment from 'moment';
var getOneCoachData = function() {
  return {
    id: 2,
    user_id: 10,
    name: '厉进虎',
    sex: '男',
    photo: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic_source%2F91%2F81%2Fd7%2F9181d7d8787f7e96f0017da5e61ad27d.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657877837&t=0e961fc96301c7e9f9dc6643873e082e',
    height: 170,
    weight: 75,
    area: '杨浦区',
    id_no: '320723198902054811',
    mobile: '17301781425',
    unit: '',
    position: '',
    political: '',
    education: '',
    school: '',
    outOfSchool: '2014-07',
    email: 'lambert2048@163.com',
    addr: '',
    step: 1,
    create_time: null,
    update_time: null,
    audit_id: 10,
    audit_title: '',
    audit_remark: '',
    audit_user: '',
    audit_time: null,
    audit_status: 0,
    status: 1,
  };
}

var getOneEmptyCoachItem = function() {
  return {
    id: 0,
    userId: 0,
    name: null,
    photo: null,
    height: null,
    weight: null,
    area: null,
    idNo: null,
    sex: null,
    mobile: null,
    unit: null,
    position: null,
    political: null,
    education: null,
    school: null,
    outOfSchool: null,
    email: null,
    addr: null,
  };
}

// 测试创建一个certificate数据Item
var getOnecertificateData = function() {
  return {
    id: 1,
    coach_id: 2,
    name: '社会体育指导员职业资格证书',
    level: '一级/高级技师',
    date_of_issue: '2013-04-05',
    sn: 'SHSLQJLY001X',
    unit: '上海市篮球协会',
    photo: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic_source%2F91%2F81%2Fd7%2F9181d7d8787f7e96f0017da5e61ad27d.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657877837&t=0e961fc96301c7e9f9dc6643873e082e|https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg1.jc001.cn%2Fimg%2F839%2F1595839%2F1309%2F13523d4b75bf35f.jpg&refer=http%3A%2F%2Fimg1.jc001.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658029457&t=4cd986bf02beb80dfd6556e8887dfd65",
  }
}

// 生成一个空的certificateitem数据
var getOneEmptyCertificateItem = function() {
  return {
    id: 0,
    coachId: 0,
    showIndex: -1,
    name: null,
    level: null,
    dateOfIssue: null,
    sn: null,
    unit: null,
    photo: null,
  };
}
// 测试创建一个resume数据Item
var getOneResumeData = function() {
  return {
    id: 1,
    coach_id: 2,
    unit: '上海市徐汇中心小学',
    title: '体育老师兼校队教练',
    begin_date: '2013-09',
    end_date: '2016-07',
    results: '负责，认真，和善，技术成熟。',
    photo: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic_source%2F91%2F81%2Fd7%2F9181d7d8787f7e96f0017da5e61ad27d.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657877837&t=0e961fc96301c7e9f9dc6643873e082e|https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg1.jc001.cn%2Fimg%2F839%2F1595839%2F1309%2F13523d4b75bf35f.jpg&refer=http%3A%2F%2Fimg1.jc001.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658029457&t=4cd986bf02beb80dfd6556e8887dfd65",
  }
}

// 生成一个空的resumeitem数据
var getOneEmptyResumeItem = function() {
  return {
    id: 0,
    coachId: -1,
    unit: null,
    title: null,
    beginDate: null,
    endDate: null,
    results: null,
    photo: null,
  }
}

// 测试创建一个cultivate数据Item
var getOneCultivateData = function() {
  return {
    id: 1,
    coach_id: 2,
    name: '上海市第四届教练培训班',
    unit: '上海市篮球协会',
    location: '上海市杨浦区',
    begin_date: '2013-09',
    end_date: '2016-07',
    photo: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic_source%2F91%2F81%2Fd7%2F9181d7d8787f7e96f0017da5e61ad27d.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1657877837&t=0e961fc96301c7e9f9dc6643873e082e|https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg1.jc001.cn%2Fimg%2F839%2F1595839%2F1309%2F13523d4b75bf35f.jpg&refer=http%3A%2F%2Fimg1.jc001.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658029457&t=4cd986bf02beb80dfd6556e8887dfd65",
  }
}

// 生成一个空的cultivateitem数据
var getOneEmptyCultivateItem = function() {
  return {
    id: 0,
    coachId: -1,
    name: null,
    unit: null,
    location: null,
    beginDate: null,
    endDate: null,
    photo: null,
  }
}

//分割图片字符串并转换为图片item模型列表
var splitImageUrlToPictures = function(imageStr, separator, namePrefix) {
  if (imageStr == undefined || imageStr == null || imageStr == '') {
    return null;
  }
  if (separator == undefined || separator == null || separator == '') {
    return [imageStr];
  }
  let prefixTitle = namePrefix;
  if (namePrefix == undefined || namePrefix == null || namePrefix == '') {
    prefixTitle = 'picture_item_';
  }
  let pictureList = [];
  let tmp = imageStr.split(separator);
  for(let i = 0; i < tmp.length; i++) {
    let picture = {
      name: prefixTitle + i,
      url: tmp[i]
    };
    pictureList.push(picture);
  }
  return pictureList;
}

//将certificate数据转换为数据提交模型
var transferCertItemToCertModel = function(item) {
  if (item == undefined || item == null) {
    return;
  }
  let model = {};
  for (let key in item) {
    let value = item[key];
    if (key == 'strDateOfIssue') {
      continue;
    }
    if (key == 'dateOfIssue') {
      if (value != null) {
        model['strDateOfIssue'] = moment(value).format("yyyy-MM-DD");
      }  else {
        model['strDateOfIssue'] = '';
      }
      continue;
    }

    if (key != "photo") {
      if (value == null) {
        value = '';
      }
      model[key] = value;
    } else {
      if (value == null || value == '') {
        value = '';
        model['photos'] = [];
      } else {
         // 此处为分割图片string的分割符
        let pictureList = splitImageUrlToPictures(value, ',', "coach_picture_" + item.id + "_item_");
        model['photos'] = pictureList;
      }
    }
  }
  model.uuid = getDefultUUidString();
  return model;
}
// 将证书certificate数据列表转换为数据模型列表
var transferCertDataListToCertModelList = function (dataList) {
  if (dataList == undefined || dataList == null || dataList.length == 0) {
    return null;
  }

  let modelList = [];

  for(let i = 0; i < dataList.length; i++) {
    let model = transferCertItemToCertModel(dataList[i]);
    modelList.push(model);
  }
  return modelList;
}

//
var transferResumeItemToResumeModel = function(item) {
  if (item == undefined || item == null) {
    return;
  }
  let model = {};
  for (let key in item) {
    let value = item[key];
    if (key == 'strBeginDate' || key == 'strEndDate') {
      continue;
    }

    if (key == 'beginDate') {
      if (value == null) {
        model['strBeginDate'] = '';
      } else {
        model['strBeginDate'] = moment(value).format("yyyy-MM-DD");
      }
      continue;
    }

    if (key == 'endDate') {
      if (value == null) {
        model['strEndDate'] = '';
      } else {
        model['strEndDate'] = moment(value).format("yyyy-MM-DD");
      }
      continue;
    }

    if (key != "photo") {
      if (value == null) {
        value = '';
      }
      model[key] = value;
    } else {
      if (value == null || value == '') {
        value = '';
        model['photos'] = [];
      } else {
         // 此处为分割图片string的分割符
        let pictureList = splitImageUrlToPictures(value, ',', "resume_picture_" + item.id + "_item_");
        model['photos'] = pictureList;
      }
    }
  }
  model.uuid = getDefultUUidString();
  return model;
}

var transferResumeDataListToResumeModelList = function (dataList) {
  if (dataList == undefined || dataList == null || dataList.length == 0) {
    return null;
  }
  let modelList = [];
  for(let i = 0; i < dataList.length; i++) {
    let model = transferResumeItemToResumeModel(dataList[i]);
    modelList.push(model);
  }
  return modelList;
}


var transferCultivateItemToCultivateModel = function(item) {
  if (item == undefined || item == null) {
    return;
  }
  let model = {};
  for (let key in item) {
    let value = item[key];
    if (key == 'strBeginDate' || key == 'strEndDate') {
      continue;
    }

    if (key == 'beginDate') {
      if (value == null) {
        model['strBeginDate'] = '';
      } else {
        model['strBeginDate'] = moment(value).format("yyyy-MM-DD");
      }
      continue;
    }

    if (key == 'endDate') {
      if (value == null) {
        model['strEndDate'] = '';
      } else {
        model['strEndDate'] = moment(value).format("yyyy-MM-DD");
      }
      continue;
    }

    if (key != "photo") {
      if (value == null) {
        value = '';
      }
      model[key] = value;
    } else {
      if (value == null || value == '') {
        value = '';
        model['photos'] = [];
      } else {
         // 此处为分割图片string的分割符
        let pictureList = splitImageUrlToPictures(value, ',', "cultivate_picture_" + item.id + "_item_");
        model['photos'] = pictureList;
      }
    }
  }
  model.uuid = getDefultUUidString();
  return model;
}

var transferCultivateDataListToCultivateModelList = function (dataList) {
  if (dataList == undefined || dataList == null || dataList.length == 0) {
    return null;
  }
  let modelList = [];
  for(let i = 0; i < dataList.length; i++) {
    let model = transferCultivateItemToCultivateModel(dataList[i]);
    modelList.push(model);
  }
  return modelList;
}

var transferCoachtemToCertModel = function(item) {
  if (item == undefined || item == null) {
    return;
  }
  let model = {
    id: null,
    userId: null,
    name: null,
    photo: null,
    height: 0,
    weight: 0,
    area: null,
    idNo: null,
    // sex: null,
    mobile: null,
    unit: null,
    position: null,
    political: null,
    education: null,
    school: null,
    strOutOfSchool: null,
    email: null,
    addr: null,
  };
  for (let key in model) {
    let value = null;
    if(key == 'strOutOfSchool') {
      value = item['outOfSchool'];
      if (value == null) {
        value = '';
      } else {
        value = moment(value).format("yyyy-MM-DD");
      }
    } else {
      value = item[key];
    }

    if (value == null) {
      value = '';
    }
    model[key] = value;
  }
  return model;
}


var deepCopy = function(target) {
  if (typeof target == 'object' && target != null) {
    let copiedTarget = Array.isArray(target) ? [] : {};
    for (let prop in target) {
      if (Object.prototype.hasOwnProperty.call(target, prop)) {
       copiedTarget[prop] = deepCopy(target[prop]);
      }
    }
    return copiedTarget;
  } else {
    return target;
  }
}
//判断是说有都有值: null, '', [], 皆为空, 此处主要判断字符串，和 列表，item默认为Ojbect
var isItemAllFilled = function(item) {
  if (item == undefined || item == null) {
    return false;
  }
  if (typeof item == 'string') { // 字符串
    return item != '';
  }
  if (typeof item == 'number') { // 数字
    return true;
  }
  if (typeof item != 'object') { // 非object
    return false;
  }

  if (Array.isArray(item)) { // item为列表
    return item.length > 0;
  }
  let isFilled = true;
  outLoop:
  for(let key in item) {
    let value = item[key];
    let returnKey = isItemAllFilled(value);
    if (!returnKey) {
      isFilled = false;
      break outLoop;
    }
  }
  return isFilled;
}

var isDeepEqualed = function(item1, item2) {
  if(item1 == undefined || item2 == undefined) {
    return false;
  }
  if(typeof item1 != typeof item2) {
    return false;
  }

  //剔除null
  if (item1 == null && item2 == null) {
    return true;
  }

  if (item1 == null || item2 == null) {
    return false;
  }

  if (typeof item1 != 'object') { // string， number等
    return item1 == item2;
  }
  let bool1 = Array.isArray(item1);
  let bool2 = Array.isArray(item2);
  if (bool1 != bool2) {
    return false;
  }

  if (!bool1) { // object 非数组
    let keys1 = Object.getOwnPropertyNames(item1);
    let keys2 = Object.getOwnPropertyNames(item2);

    let unexpectedList = ['__ob__', 'uid', 'status'];
    for (let i = 0; i < unexpectedList.length; i++) {
      let item = unexpectedList[i];
      let tempFunc = function(key) {
        return item == key;
      };
      let index1 = keys1.findIndex(tempFunc);
      if (index1 >= 0) {
        keys1.splice(index1, 1);
      }

      let index2 = keys2.findIndex(tempFunc);
      if (index2 >= 0) {
        keys2.splice(index2, 1);
      }
    }

    if (keys1.length != keys2.length) {
      return false;
    }
    let isEqual = true;
    outLoop:
    for(let i = 0; i < keys1.length; i++) {
      let propName = keys1[i];
      let value1 = item1[propName];
      let value2 = item2[propName];
      if(!item2.hasOwnProperty(propName)) {
        isEqual = false;
        break outLoop;
      }

      let returnValue = isDeepEqualed(value1, value2);
      if (!returnValue) {
        isEqual = false;
        break outLoop;
      }
    }
    return isEqual;
  }

  //此处都为列表
  if (item1.length != item2.length) {
    return false;
  }

  let isEqual = true;
  for(let i = 0; i < item1.length; i++) {
    let value1 = item1[i];
    let value2 = item2[i];
    let returnValue = isDeepEqualed(value1, value2);
    if (!returnValue) {
      isEqual = false;
      break;
    }
  }
  return isEqual;
}
var getDefultUUidString = function() {
  return getUuidString(32, 60);
}

var getUuidString = function(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    for(i = 0; i < len; i++) {
      uuid[i]= chars[0 | Math.random() *radix];
    }
  } else {
      var r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
      for(i = 0; i < 36; i++) {
        if(!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i==19) ? (r & 0x3) | 0x8 : r];
        }
      }
  }
  return uuid.join('');
}

export default {
  methods: {
    coach: {
      getOneData: getOneCoachData,
      getModelFromItem: transferCoachtemToCertModel,
      getEmptyItem: getOneEmptyCoachItem,
    },
    certificate: {
      getOneData: getOnecertificateData,
      getEmptyItem: getOneEmptyCertificateItem,
      getModelFromItem: transferCertItemToCertModel,
      getModelListFromDataList: transferCertDataListToCertModelList,
    },
    resume: {
      getOneData: getOneResumeData,
      getEmptyItem: getOneEmptyResumeItem,
      getModelFromItem: transferResumeItemToResumeModel,
      getModelListFromDataList: transferResumeDataListToResumeModelList,
    },
    cultivate: {
      getOneData: getOneCultivateData,
      getEmptyItem: getOneEmptyCultivateItem,
      getModelFromItem: transferCultivateItemToCultivateModel,
      getModelListFromDataList: transferCultivateDataListToCultivateModelList,
    }
  },
  tools: {
    deepCopy: deepCopy,
    isItemAllFilled: isItemAllFilled,
    isDeepEqualed: isDeepEqualed,
  }
}



// WEBPACK FOOTER //
// ./src/js/coach/data-creator.js